export default "__VITE_ASSET__DHhFD$cf__"